import { FC } from 'react'

import { useAppSelector } from 'src/Hooks/redux'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { getIsNewUserForVideosBased } from 'src/Redux/auth-process/userSlice/selectors'
import { ModalType } from 'src/Types/ui'

import { TiktokScheduleCommentModal } from './TiktokScheduleCommentModal'
import { TiktokScheduleCreatorTypeModal } from './TiktokScheduleCreatorTypeModal'

export const TiktokScheduleSettingsModals: FC = () => {
  const { search } = useCustomSearchParams()
  const isNewUserForVideosBased = useAppSelector(getIsNewUserForVideosBased)

  const modalType = search.get('modal')

  if (modalType === ModalType.Comment) {
    return <TiktokScheduleCommentModal />
  }
  if (modalType === ModalType.CreatorType && !isNewUserForVideosBased) {
    return <TiktokScheduleCreatorTypeModal />
  }
  return null
}
